import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogTextValueData } from 'src/app/models/dialog-text-value-data';

@Component({
  selector: 'app-dialog-text-value',
  templateUrl: './dialog-text-value.component.html',
  styleUrls: ['./dialog-text-value.component.css']
})
export class DialogTextValueComponent {

  public constructor(
    private dialogRef: MatDialogRef<DialogTextValueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogTextValueData
  ) {

  }

  public closeDialog(): void {
    this.dialogRef.close({
      [this.data.idTabelaPai]: this.data.idTabela,
      [this.data.textName]: this.data.textValue,
      [this.data.numberName]: this.data.numberValue
    });
  }

  public cancelDialog(): void {
    this.dialogRef.close();
  }
}
